Devuelve la lista paginada de campañas de la organización autenticada por la credencial.

## Paginación

- Use `page` para navegar entre páginas.
- Use `page_size` para controlar el tamaño de página.
- El contrato sigue el envelope estándar `count`, `next`, `previous` y `results`.
- `page` es 1-based.
- `page_size` tiene default `25` y máximo `100`.

## Filtros y ordenación

- `status`: acepta uno o más estados de campaña, separados por coma.
- `campaign_type`: acepta uno o más tipos de campaña, separados por coma.
- `ai_agent_provider_id`: filtra por uno o más IDs de proveedor.
- `ai_agent_id`: filtra por uno o más IDs de agente.
- `created_by`: filtra por uno o más IDs de usuarios creadores.
- `ordering`: acepta los campos públicos documentados para ordenación.
- `search`: búsqueda textual en `name` y `description`.

<ApiCodeExamples exampleId="campaignsList" />

<ApiResponseExamples exampleId="campaignsList" />

## Campos principales por ítem

- `id`: ID de la campaña.
- `canonical_url`: enlace canónico de la campaña en la app Contact-Tel.
- `created_by_id`, `created_by_name`: referencia del usuario creador.
- `status`: estado persistido de la campaña.
- `campaign_type`: modalidad operativa de la campaña.
- `ai_agent_provider_id`, `ai_agent_id`, `sip_trunk_id`: IDs públicos de recursos relacionados.
- `ai_agent_provider_name`, `ai_agent_name`, `sip_trunk_name`: etiquetas visibles.
- `transfer_target_type`, `transfer_target_id`, `transfer_target_name`, `transfer_target_extension`: destino de transferencia configurado, cuando exista.
- `total_contacts`, `pending_contacts`, `reached_contacts`: contadores de progreso.
- `total_calls`, `connected_calls`, `converted_calls`: vista operativa de llamadas.
- `ai_billed_seconds`, `ai_gross_billed_seconds`, `ai_refunded_seconds`: consumo de IA líquido, bruto y estornado.
- `telephony_billed_seconds`, `telephony_gross_billed_seconds`, `telephony_refunded_seconds`: consumo de telefonía líquido, bruto y estornado.
- `progress_percentage`: progreso derivado de los contadores de la campaña.

## Referencia de opciones

- `status`: `draft` aún no está lista; `processing` prepara/importa contactos; `ready` puede iniciar; `active` está en ejecución; `paused` está pausada; `completed` terminó; `cancelled` fue cancelada.
- `status_reason`: `import_failed` indica bloqueo por importación; `config_error` indica bloqueo por configuración; `paused` es pausa operacional normal; `null` significa sin motivo público adicional.
- `campaign_type`: `ai` es campaña con agente de IA; `reverse_ivr` es campaña de URA reversa.
- `ai_agent_provider_type`: `cloud`, `asterisk` o `sip`.
- `transfer_target_type`: `user`, `group` o `null`.
- `import_status`: `idle`, `processing`, `completed` o `failed`.

## Cuándo usar este endpoint

- listar campañas de la organización en herramientas externas de supervisión;
- alimentar dashboards externos;
- acompañar el progreso operativo sin usar la interfaz administrativa.
